document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-nav');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('is-open', !open);
  });
  document.querySelectorAll('[data-product-thumb]').forEach((button) => button.addEventListener('click', () => {
    const image = document.querySelector('[data-product-main-image]');
    if (image && button.dataset.src) image.src = button.dataset.src;
  }));
  const select = document.querySelector('[data-product-select]');
  select?.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const price = document.querySelector('[data-product-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });
  const age = document.querySelector('[data-age-check]');
  const checkout = document.querySelector('[data-checkout-with-age]');
  age?.addEventListener('change', () => { if (checkout) checkout.disabled = checkout.hasAttribute('data-invalid-wine-gift') || !age.checked; });
  document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    const addon = form.querySelector('[data-product-addon]:checked');
    if (!addon) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const data = new FormData(form);
    const properties = {};
    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    }
    button.disabled = true; button.textContent = 'Adding…';
    const response = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({ items:[{ id:Number(data.get('id')), quantity:Number(data.get('quantity') || 1), properties },{ id:Number(addon.dataset.addonId), quantity:1, properties:{'Added to':document.querySelector('.product-information h1')?.textContent.trim() || 'Hamper'} }] }) });
    if (response.ok) window.location.href='/cart';
    else { button.disabled=false; button.textContent='Add to gift bag'; alert('The items could not be added. Please check availability and try again.'); }
  }));
});
